import { render } from "./TheSearchImage.vue?vue&type=template&id=6ae55606&scoped=true&ts=true"
import script from "./TheSearchImage.vue?vue&type=script&lang=ts"
export * from "./TheSearchImage.vue?vue&type=script&lang=ts"

import "./TheSearchImage.vue?vue&type=style&index=0&id=6ae55606&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae55606"]])

export default __exports__